// Längen für Seitentitel und Meta-Beschreibung, wie Suchmaschinen sie anzeigen.
// Ahrefs meldete am 07.10.2026 53 zu lange Titel und 86 zu lange
// Beschreibungen, fast alle aus Blog- und Case-Daten. Titel und Slugs in der
// Datenbank bleiben unverändert, gekürzt wird nur die Ausgabe im <head>.

export const MAX_TITLE_LENGTH = 60;
export const MAX_DESCRIPTION_LENGTH = 155;

/** Hängt den Zusatz nur an, wenn der Titel damit noch in die Grenze passt. */
export function pageTitle(title: string, suffix: string, max = MAX_TITLE_LENGTH): string {
  const withSuffix = `${title}${suffix}`;
  return withSuffix.length <= max ? withSuffix : title;
}

/** Kürzt an einer Wortgrenze und schließt mit „…“ ab. */
export function metaDescription(text: string, max = MAX_DESCRIPTION_LENGTH): string {
  const clean = text.replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;
  const cut = clean.slice(0, max - 1);
  const lastSpace = cut.lastIndexOf(" ");
  const base = lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut;
  return `${base.replace(/[\s,;:.–-]+$/, "")}…`;
}
